/* eslint-disable no-nested-ternary */
import React from 'react';

import PropTypes from 'prop-types';
import { Button, Typography } from '@telus-uds/components-web';
import Close from '@telus-uds/palette-allium/build/web/icons/Close';

import request from '../../utils/request';
import {
  Backdrop,
  ModalMain,
  ModalInner,
  ModalMessageMain,
  ModalCancel,
  ModalHeading,
  ChannelTag,
  SummaryDetail
} from './css';
import { AccountCategory, SummaryGroupWrapper } from '../../form/css';
import { profileKeysToList, roleDescription } from '../../utils/constant';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';

const AccountInfo = ({ onClose, dealership }) => {
  const localizedStrings = useLocalizedStringsContext();
  const { profileKeys } = localizedStrings;
  const profile = request.getProfile();

  // const getComma = index => {
  //   return profile.channels.length - 1 !== index ? <span>,&nbsp;</span> : '';
  // };

  // const getChannels = () => {
  //   return (
  //     <>
  //       {profile.channels.map((c, index) => (
  //         <span>
  //           {c.description}
  //           {getComma(index)}
  //         </span>
  //       ))}
  //     </>
  //   );
  // };

  const getChannels = channels => {
    if (channels.length === 1) return channels[0].description;
    return channels.map(channel => (
      <ChannelTag>{channel.description}</ChannelTag>
    ));
  };

  return (
    <Backdrop>
      <ModalMain>
        <ModalInner>
          <ModalMessageMain>
            <ModalHeading>My Account Info</ModalHeading>
            {profile &&
              profileKeysToList.map(key => {
                if (profile[key])
                  return (
                    <SummaryGroupWrapper key={`rep-info-${key}`}>
                      <AccountCategory>
                        <Typography>
                          {profileKeys[key]}
                        </Typography>
                      </AccountCategory>
                      <SummaryDetail>
                        {key === 'channelName'
                          ? getChannels(profile.channels)
                          : key === 'role'
                          ? roleDescription[profile.role.name]
                          : { ...profile, dealership }[key]}
                      </SummaryDetail>
                      <div className="clear" />
                    </SummaryGroupWrapper>
                  );
                return null;
              })}
          </ModalMessageMain>
          <ModalCancel>
            <Button
              icon={Close}
              onPress={onClose}
              accessibilityLabel="Close"
              variant={{ text: true }}
            />
          </ModalCancel>
        </ModalInner>
      </ModalMain>
    </Backdrop>
  );
};

AccountInfo.propTypes = {
  onClose: PropTypes.func.isRequired,
  dealership: PropTypes.func.isRequired
};

export default AccountInfo;
